import React, { useEffect, useState } from "react";
import client, { mediaUrl } from "../lib/api";
import Layout, { PageHero } from "../components/site/Layout";
import { EmptyState, FocusCard } from "../components/site/common";
import { HardHat } from "lucide-react";

export default function Projects() {
  const [projects, setProjects] = useState([]);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { client.get("/public/projects").then(({ data }) => setProjects(data)).catch(() => {}).finally(() => setLoaded(true)); }, []);

  return (
    <Layout>
      <PageHero eyebrow="Projects" title="Building Meaningful Initiatives" intro="Details of the Trust's initiatives and community programs will be published here as they are established and implemented." />
      <section className="mx-auto max-w-7xl px-5 py-20 lg:px-10 lg:py-24">
        {loaded && projects.length === 0 ? (
          <EmptyState icon={HardHat} title="No projects published yet" message="The Trust is presently developing its initiatives and operational programs. Verified projects will appear here once officially established." />
        ) : (
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {projects.map((p) => (
              <div key={p.id} className="border border-gold/20 bg-white" data-testid={`project-${p.id}`}>
                {p.image && <div className="aspect-video overflow-hidden bg-ivory"><img src={mediaUrl(p.image)} alt={p.name} className="h-full w-full object-cover" /></div>}
                <div className="p-7">
                  {p.category && <div className="eyebrow mb-2">{p.category}</div>}
                  <h3 className="text-xl font-medium text-maroon">{p.name}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-ink-muted">{p.shortDescription}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </Layout>
  );
}
